import axios from '@/utils/axios'
// import qs from 'qs'
// import request from '@/utils/request'
// 页面绑定列表
export function listBind(query) {
    return axios({
        url: '/video/bindpath/getList',
        method: 'get',
        params: query
    })
}
// 添加绑定
export function addBind(query) {
    return axios({
        url: '/video/bindpath/bindPath',
        method: 'post',
        params: query
    })
}
// 删除绑定
export function delBind(query) {
    return axios({
        url: '/video/bindpath/delete',
        method: 'get',
        params: query
    })
}